export default __webpack_public_path__ + "static/media/3.aa15d90d.png";